export default __webpack_public_path__ + "images/AN.2af6865.png";